module.exports = __webpack_public_path__ + "static/media/pmag-alpha.9486a5ae.png";